module.exports = __webpack_public_path__ + "media/images/iconPaginateNext-15f4775da0ad5b70970e4512f3315636.png";